import { useEffect } from 'react';

const TAWK_SCRIPT_URL = 'https://embed.tawk.to/6a34f1dd51481a1d487591a8/1jrfd1i23';

const TawkChat = () => {
  useEffect(() => {
    if (document.getElementById('tawk-chat-script')) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement('script');
    script.id = 'tawk-chat-script';
    script.async = true;
    script.src = TAWK_SCRIPT_URL;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);
  }, []);

  return null;
};

export default TawkChat;
